const en: Record<string, string> = {
  'features.guitarNotes.showNote': 'Show',
  'features.guitarNotes.hideNote': 'Hide',
  'features.guitarNotes.nextNote': 'Next',
  'features.guitarNotes.notes': 'Notes',
  'features.guitarNotes.octaves': 'Octaves',
  'features.guitarNotes.loadingSamples': 'Loading guitar samples…',
  'features.guitarNotes.modeAuto': 'Auto',
  'features.guitarNotes.modeManual': 'Manual',
  'features.guitarNotes.stop': 'Stop',
  'features.guitarNotes.resume': 'Resume',
  'features.guitarNotes.hideDuration': 'Thinking',
  'features.guitarNotes.revealDuration': 'Reveal',
  'features.guitarNotes.fretCount': 'Frets',
  'features.guitarNotes.repeatNote': 'Repeat',
  'features.guitarNotes.muteSound': 'Mute',
  'features.guitarNotes.unmuteSound': 'Unmute',
  'features.guitarNotes.showFretboard': 'Show fretboard',
  'features.guitarNotes.hideFretboard': 'Hide fretboard',
};

export default en;
